<div class="added-area">
  <div class="added-top">
    <h3>Request Medicine</h3>
    <span (click)="onClose()"><i class="fa fa-xmark"></i></span>
  </div>
  <div class="added-form">
    <form (ngSubmit)="onFormSubmit()" [formGroup]="dataForm">

      <div class="drop-image-area">
        <div class="drop-zone-main">
          <app-drop-zone (newItemEvent)=" onSelect($event)"
                         (onDeleteOldImage)="onDeleteOldImage($event)"
                         [fileNotPicked]="fileNotPicked"
                         [images]="oldImages"></app-drop-zone>
        </div>
      </div>

      <div class="form-input-select">
        <mat-form-field appearance="outline" class="w-100 d-block field">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" type="text" placeholder="Enter your name"/>
          <mat-error>This field is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-input-select">
        <!--        <mat-form-field class="w-100 d-block field" appearance="outline">-->
        <!--          <mat-label>Select Division</mat-label>-->
        <!--          <mat-select formControlName="division" (selectionChange)="onChangeRegion($event)">-->
        <!--            <mat-option [value]="d?._id" *ngFor="let d of divisions">{{d?.name}}</mat-option>-->
        <!--          </mat-select>-->
        <!--          <mat-error>This field is required</mat-error>-->
        <!--        </mat-form-field>-->
        <div class="form-input-area">
          <div class="country">
            <app-general-dropdown
              [inputData]="divisions"
              [placeHolderId]="dataForm.value?.division"
              [label]="'District'"
              (passDataEvent)="onChangeRegion($event)"
            ></app-general-dropdown>
          </div>
        </div>
      </div>

      <div class="form-input-select">
        <!--        <mat-form-field class="w-100 d-block field" appearance="outline">-->
        <!--          <mat-label>Select Area</mat-label>-->
        <!--          <mat-select formControlName="area" (selectionChange)="onChangeArea($event)">-->
        <!--            <mat-option [value]="a?._id" *ngFor="let a of area">{{a?.name}}</mat-option>-->
        <!--          </mat-select>-->
        <!--          <mat-error>This field is required</mat-error>-->
        <!--        </mat-form-field>-->
        <div class="form-input-area">
          <div class="country">
            <app-general-dropdown
              [inputData]="area"
              [placeHolderId]="dataForm.value?.area"
              [label]="'Area'"
              (passDataEvent)="onChangeArea($event)"
            ></app-general-dropdown>
          </div>
        </div>
      </div>
      <div class="form-input-select">
        <!--        <mat-form-field class="w-100 d-block field" appearance="outline">-->
        <!--          <mat-label>Select Zone</mat-label>-->
        <!--          <mat-select formControlName="zone">-->
        <!--            <mat-option [value]="z?._id" *ngFor="let z of zone">{{z?.name}}</mat-option>-->
        <!--          </mat-select>-->
        <!--          <mat-error>This field is required</mat-error>-->
        <!--        </mat-form-field>-->
        <div class="form-input-area">
          <div class="country">
            <app-general-dropdown
              [inputData]="zone"
              [placeHolderId]="dataForm.value?.zone"
              [label]="'Select Upozila/Thana'"
              (passDataEvent)="onChangeZone($event)"
            ></app-general-dropdown>
          </div>
        </div>
      </div>
      <div class="form-input-select">
        <mat-form-field appearance="outline" class="w-100 d-block field">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phoneNo" type="text" placeholder="phone number"/>
          <mat-error>This field is required</mat-error>
          <mat-hint>Please enter your 11 digit mobile number..</mat-hint>
        </mat-form-field>
      </div>


      <!--      <div formArrayName="medicineInfo" class="form-array-input">-->
      <!--        <div class="single-field"-->
      <!--             *ngFor="let data of mondayHoursArray?.controls; let i = index; let last = last"-->
      <!--             [formGroupName]="i">-->

      <!--          <div class="form-input-select time-picker">-->
      <!--            <label for="name">Medicine name</label>-->
      <!--            <div class="input-main">-->
      <!--              <input type="text" id="name" placeholder="Enter name" formControlName="medicineName"/>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <div class="form-input-select time-picker">-->
      <!--            <label for="quantity">Quantity</label>-->
      <!--            <div class="input-main">-->
      <!--              <input type="time" id="quantity" placeholder="Enter quantity" formControlName="quantity"/>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <button *ngIf="!last" type="button" mat-mini-fab color="warn" (click)="removeFormArrayField(i)">-->
      <!--            <mat-icon>delete</mat-icon>-->
      <!--          </button>-->
      <!--          <button *ngIf="last" type="button" mat-mini-fab color="primary" (click)="onAddNewFormArrayObject()">-->
      <!--            <mat-icon>add</mat-icon>-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="form-array-container">
        <div formArrayName="medicineInfo" class="form-array-input">
          <div class="single-field" *ngFor="
                let data of medicineDataArray?.controls;
                let i = index
              " [formGroupName]="i">

            <mat-form-field appearance="outline">
              <mat-label>Name</mat-label>
              <input formControlName="name" type="text" matInput [placeholder]="'Enter Name'"/>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Quantity</mat-label>
               <input formControlName="value" type="text" matInput [placeholder]="'Enter Quantity'"/>
<!--              <textarea formControlName="value" matInput placeholder="Enter value" [rows]="1"></textarea>-->
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Generic</mat-label>
               <input formControlName="genericName" type="text" matInput [placeholder]="'Enter Generic'"/>
            </mat-form-field>

            <button class="btn-form-field-remove" type="button" mat-mini-fab color="warn"
                    (click)="removeFeaturesFormArrayField('medicineInfo', i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="add-form-array-action">
          <button type="button" mat-raised-button color="primary" (click)="onAddNewMedicineInfo()">
            <mat-icon>add</mat-icon>
            Add Medicine
          </button>
        </div>
      </div>


      <div class="form-input-select">

<!--        <div class="form-input-select">-->
<!--          <mat-form-field appearance="outline" class="w-100 d-block field">-->
<!--            <mat-label>Generic Name</mat-label>-->
<!--            <input matInput formControlName="genericName" type="text" placeholder="Generic Name"/>-->
<!--            <mat-error>This field is required</mat-error>-->

<!--          </mat-form-field>-->
<!--        </div>-->

        <h3 style="margin-bottom: 6px!important;">Notes</h3>
        <mat-form-field appearance="outline" class="w-100 d-block field">
          <mat-label>Ex: 1. Alfavir 10mg = 1 pcs/stripe/box</mat-label>
          <textarea matInput formControlName="orderNotes" placeholder="Medicine Details" cols="5" rows="3"></textarea>
          <mat-error>This field is required</mat-error>
        </mat-form-field>
      </div>
      <div class="add-btn">
        <button type="submit" mat-button>{{isLoading ? 'Please Wait..' : 'Submit Request'}}</button>
      </div>
    </form>
  </div>
</div>
